<div class="admin-layout">
  <p-menubar [model]="menuItems">
    <ng-template pTemplate="start">
      <div class="admin-logo">
        <i class="pi pi-palette"></i>
        <span>CanvasBloom Admin</span>
      </div>
    </ng-template>
    <ng-template pTemplate="end">
      <p-button label="Logout" icon="pi pi-sign-out" [text]="true" severity="secondary" (onClick)="logout()" />
    </ng-template>
  </p-menubar>

  <div class="admin-content">
    <router-outlet></router-outlet>
  </div>
</div>
